import React, { useState } from 'react'
import { useFormatMessage } from '@babylon/intl'
import { Snackbar } from '@babylon/core-ui'
import { useHistory } from 'react-router-dom'

import { messages } from './messages'
import styles from './styles.module.scss'
import { SupplyNetworksDataGrid } from './SupplyNetworksDataGrid'

export const SupplyNetworks = () => {
  const fm = useFormatMessage()

  const history = useHistory()
  const [showBanner, setShowBanner] = useState(true)

  return (
    <>
      {showBanner && (
        <Snackbar
          open
          fill
          intent="warning"
          fixed={false}
          onClose={() => setShowBanner(false)}
          className={styles.Banner}
        >
          <button
            type="button"
            className={styles.BannerButton}
            onClick={() => history.push('/admin/supply_networks')}
          >
            {fm(messages.new_supply_networks_switch_banner)}
          </button>
        </Snackbar>
      )}
      <SupplyNetworksDataGrid />
    </>
  )
}
